import {CommonRootState} from '../types';

export const selectFeatureFlag = (state: CommonRootState, flag: string) =>
  state.featureFlags?.flags?.[flag] ?? false;

export const selectWebSubscriptionEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['web_subscription'] ?? false;

export const selectCameraEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['camera'] ?? false;

export const selectStripeConfig = (state: CommonRootState) =>
  state.featureFlags?.stripeConfig ?? null;

export const selectDonationEnabled = (state: CommonRootState) =>
  state.featureFlags?.donationEnabled ?? false;
